/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_QueueInputs */

const en_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Queue`)
};

const fr_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File d’attente`)
};

const de_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobwarteschlange`)
};

const it_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coda di lavoro`)
};

const ru_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очередь заданий`)
};

const es_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cola de trabajos`)
};

const zh_cn2_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作业队列`)
};

const ja_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブキュー`)
};

const hi_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी कतार`)
};

const pt_pt2_job_queue = /** @type {(inputs: Job_QueueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fila de tarefas`)
};

/**
* | output |
* | --- |
* | "Job Queue" |
*
* @param {Job_QueueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_queue = /** @type {((inputs?: Job_QueueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_QueueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_queue(inputs)
	if (locale === "de") return de_job_queue(inputs)
	if (locale === "it") return it_job_queue(inputs)
	if (locale === "ru") return ru_job_queue(inputs)
	if (locale === "es") return es_job_queue(inputs)
	if (locale === "zh-CN") return zh_cn2_job_queue(inputs)
	if (locale === "ja") return ja_job_queue(inputs)
	if (locale === "hi") return hi_job_queue(inputs)
	if (locale === "pt-PT") return pt_pt2_job_queue(inputs)
	return en_job_queue(inputs)
});